/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Createtitle1Inputs */

const zh_course_createtitle1 = /** @type {(inputs: Course_Createtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建课程`)
};

const en_course_createtitle1 = /** @type {(inputs: Course_Createtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Course`)
};

const es_course_createtitle1 = /** @type {(inputs: Course_Createtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear Curso`)
};

/**
* | output |
* | --- |
* | "Create Course" |
*
* @param {Course_Createtitle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_createtitle1 = /** @type {((inputs?: Course_Createtitle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Createtitle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_createtitle1(inputs)
	if (locale === "en") return en_course_createtitle1(inputs)
	return es_course_createtitle1(inputs)
});
export { course_createtitle1 as "course_createTitle" }